import { render, staticRenderFns } from "./SavedRecords.vue?vue&type=template&id=00bf14f6&scoped=true&"
import script from "./SavedRecords.vue?vue&type=script&lang=js&"
export * from "./SavedRecords.vue?vue&type=script&lang=js&"
import style0 from "./SavedRecords.vue?vue&type=style&index=0&id=00bf14f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf14f6",
  null
  
)

export default component.exports